<ng-container *transloco="let t">
  @if (hasBrand()) {
    <app-strategy-list />
  }
  @if (hasBrand() === false) {
    <div class="m-4">{{ t("sd-manager.sd_only_for_sellers") }}</div>
  }
</ng-container>
